'use strict';

var cov_2pj1xkepi4 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/m2o/m2o.component.js',
      hash = '8dff4106bc64caccf2a59a56a2e215414b3acef4',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/m2o/m2o.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 21
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 25
        }
      },
      '2': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 10,
          column: 5
        }
      },
      '3': {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 57
        }
      },
      '4': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 16,
          column: 5
        }
      },
      '5': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 13
        }
      },
      '6': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 25
        }
      },
      '7': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 32,
          column: 7
        }
      },
      '8': {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 48,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 28
          },
          end: {
            line: 5,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 11,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 22
          },
          end: {
            line: 19,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 38
          },
          end: {
            line: 33,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }, {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 8,
            column: 8
          },
          end: {
            line: 8,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 8,
            column: 8
          },
          end: {
            line: 8,
            column: 29
          }
        }, {
          start: {
            line: 8,
            column: 33
          },
          end: {
            line: 8,
            column: 50
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 5
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 5
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 28,
            column: 36
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 28,
            column: 36
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var M2oComponent = function () {
  function M2oComponent($log, lodash) {
    _classCallCheck(this, M2oComponent);

    ++cov_2pj1xkepi4.f[0];
    ++cov_2pj1xkepi4.s[0];

    this.$log = $log;
    ++cov_2pj1xkepi4.s[1];
    this.lodash = lodash;
  }

  _createClass(M2oComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_2pj1xkepi4.f[1];
      ++cov_2pj1xkepi4.s[2];

      if ((++cov_2pj1xkepi4.b[1][0], !this.selectedElement) && (++cov_2pj1xkepi4.b[1][1], !this.firstOption)) {
        ++cov_2pj1xkepi4.b[0][0];
        ++cov_2pj1xkepi4.s[3];

        this.selectedElement = this.lodash.head(this.data);
      } else {
        ++cov_2pj1xkepi4.b[0][1];
      }
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      ++cov_2pj1xkepi4.f[2];
      ++cov_2pj1xkepi4.s[4];

      if (this.lodash(changes, 'selectedElement.currentValue', null)) {
        ++cov_2pj1xkepi4.b[2][0];
        ++cov_2pj1xkepi4.s[5];

        return;
      } else {
        ++cov_2pj1xkepi4.b[2][1];
      }

      ++cov_2pj1xkepi4.s[6];
      console.log(changes);
    }

    // compile() {
    //   console.log(this);
    //   // on prends la précaution de supprimer les éventuels doublons.
    //   // this.elements = this.lodash.uniqBy(this.data, 'id');
    //   this.elements = this.data;
    // }

  }, {
    key: 'listenChangeElement',
    value: function listenChangeElement() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_2pj1xkepi4.b[3][0], null);
      ++cov_2pj1xkepi4.f[3];
      ++cov_2pj1xkepi4.s[7];

      // emit on change.
      this.onChange({
        value: element
      });
    }
  }]);

  return M2oComponent;
}();

++cov_2pj1xkepi4.s[8];


angular.module('app').component('m2o', {
  bindings: {
    data: '=',
    firstOption: '@',
    selectedElement: '<',
    onChange: '&'
  },
  templateUrl: 'app/components/m2o/m2o.template.html',
  controller: M2oComponent
});